import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { AppComponent } from 'src/views/app/app.component';
import { AppRoutingModule } from 'src/routes/app-routing.module';
import { RegisterComponent } from 'src/views/register/register.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/modules/material.module';
import { MauticFormsModule } from './mautic-forms.module';
import { AuthModule } from './auth.module';
import { StepOneComponent } from 'src/components/step-one/step-one.component';
import { StepTwoComponent } from 'src/components/step-two/step-two.component';
import { StepThreeComponent } from 'src/components/step-three/step-three.component';
import { StepFourComponent } from 'src/components/step-four/step-four.component';
import { FinishComponent } from 'src/components/finish/finish.component';
import { NgxMaskModule } from 'ngx-mask'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CustomerModule, customCurrencyMaskConfig } from 'src/modules/customer.module';
import { ViaCepService } from 'src/services/via-cep.service';
import { CnpjService } from 'src/services/cnpj.service';
import { HttpService } from 'src/services/http.service';
import { ErrorReportService } from 'src/services/error-report.service';
import { AuthGuard } from 'src/guards/auth.guard';
import { RecruiterModule } from './recruiter.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MyMatPaginatorIntl } from 'src/services/mat-pagonator-int';
import { UploadService } from 'src/services/upload.service';
import { RegisterCompanyComponent } from 'src/views/register-company/register-company.component';
import { StepCompanyBasicInfoComponent } from 'src/components/step-company-basic-info/step-company-basic-info.component';
import { StepCompanyContactComponent } from 'src/components/step-company-contact/step-company-contact.component';

import { StepCompanySocialComponent } from 'src/components/step-company-social/step-company-social.component';
import { StepCompanySocialMauticComponent } from 'src/components/step-company-social-mautic/step-company-social-mautic.component';
import { environment } from 'src/environments/environment';
import { VersionDialogComponent } from 'src/components/version-dialog/version-dialog.component';
import { ChooseAvatarBottomsheetComponent } from 'src/components/choose-avatar-bottomsheet/choose-avatar-bottomsheet.component';
import { WebcamModule } from 'ngx-webcam';
import { WebcamDialogComponent } from 'src/components/webcam-dialog/webcam-dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SignatureStatusGuard } from 'src/guards/signature-status.guard';
import { PagseguroService } from 'src/services/pagseguro.service';
import { GerencianetService } from 'src/services/gerencianet.service';
import { PreLoginModule } from 'src/modules/pre-login.module';
import { SiteComponent } from 'src/views/site/site.component';
import { FinishCompanyComponent } from 'src/components/finish-company/finish-company.component';
import { ProcessListUserComponent } from 'src/components/process-list-user/process-list-user.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { GenericDialogComponent } from 'src/components/generic-dialog/generic-dialog.component';
import { PaymentComponent } from 'src/components/payment/payment.component';
import { HistoryDialogComponent } from 'src/components/history-dialog/history-dialog.component';
import { NotificationService } from 'src/services/notification.service';
import { NgxCurrencyModule } from "ngx-currency";
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { OneSignalService } from 'src/services/onesignal.service';
import { SendNotificationComponent } from 'src/components/send-notification/send-notification.component';
import { CommunicationService } from 'src/services/communication.service';
import { SharedModule } from './shared.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    RegisterCompanyComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponent,
    FinishComponent,
    FinishCompanyComponent,
    StepCompanyBasicInfoComponent,
    StepCompanyContactComponent,
    StepCompanySocialComponent,
    StepCompanySocialMauticComponent,
    VersionDialogComponent,
    ChooseAvatarBottomsheetComponent,
    WebcamDialogComponent,
    SiteComponent,
    ProcessListUserComponent,
    GenericDialogComponent,
    // PlanSlideComponent
    PaymentComponent,
    HistoryDialogComponent,
    SendNotificationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    LayoutModule,
    HttpClientModule,
    MauticFormsModule,
    FormsModule,
    ReactiveFormsModule,
    PreLoginModule,
    AuthModule,
    RecruiterModule,
    CustomerModule,
    NgxMaskModule.forRoot(),
    WebcamModule,
    NgxChartsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    SharedModule,
    DragDropModule
  ],
  providers: [
    ViaCepService,
    CnpjService,
    HttpService,
    UploadService,
    ErrorReportService,
    AuthGuard,
    SignatureStatusGuard,
    PagseguroService,
    GerencianetService,
    NotificationService,
    OneSignalService,
    CommunicationService,
    {
      provide: 'MIDIA_ENDPOINT',
      useValue: environment.mediaEndpoint
    },
    {
      provide: 'API_ENDPOINT',
      useValue: environment.apiEndpoint
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useClass: MyMatPaginatorIntl },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
